<template>
  <q-card style="width: 800px; max-width: 200vw;">
    <q-card-section>
      <div class="text-h6">採購審核列表</div>
    </q-card-section>

    <q-card-section>
      <div class="row q-gutter-xs">
        <div class="col col-12">
          <q-table
            title=""
            :data="purchaseCheckList"
            :columns="columns"
            row-key="title"
            :filter="filter"
            :pagination.sync="tableSet"
          >
            <template v-slot:body="props">
              <q-tr :props="props">
                <q-td key="status" :props="props">{{ purchaseCheckStatus[props.row.status] }}</q-td>
                <q-td key="check_no" :props="props">{{ props.row.check_no }}</q-td>
                <q-td key="quantity" :props="props">{{ props.row.nick_name }}</q-td>
                <q-td key="date" :props="props">{{ props.row.created_at }}</q-td>
                <q-td key="action" :props="props">
                  <q-btn color="blue" icon="edit" @click="handleRowClickEvent(props.row)"></q-btn>
                </q-td>
              </q-tr>
            </template>
          </q-table>
        </div>
      </div>
    </q-card-section>

    <q-card-actions align="right">
      <q-btn flat label="OK" color="primary" v-close-popup />
    </q-card-actions>
  </q-card>
</template>

<script>
import { mapGetters } from 'vuex'
  export default {
    name: "PurchaseCheck",
    props: {
      handleRowClickEvent: {
        type: Function
      }
    },
    data() {
      return {
        filter: '',
        columns: [
          { name: 'status', label: '狀態'},
          { name: 'check_no', align: 'center', label: '審查單號', field: 'check_no'},
          { name: 'quantity', label: '總採購數量', field: 'quantity'},
          { name: 'date', label: '建立日期'},
          { name: 'action', label: '操作', align: 'center', field: 'id' }
        ],
        tableSet: {
            sortBy: 'desc',
            descending: false,
            page: 1,
            rowsPerPage: 10
        },
      }
    },
    computed: {
      ...mapGetters(['purchaseCheckList', 'purchaseCheckStatus'])
    },
    created() {
      this.$store.dispatch("purchaseGetCheckList")
    },
  }
</script>